'use es6';

import keyMirror from 'react-utils/keyMirror';
import { Map as ImmutableMap } from 'immutable';
export var CAL_INTEGRATIONS = keyMirror({
  GOOGLE: null,
  OFFICE365: null,
  EXCHANGE: null,
  UNKNOWN: null
});
export var FORM_FIELD_TYPES = {
  DATE: 'date',
  NUMBER: 'number',
  TEXT: 'string',
  TEXTAREA: 'textarea',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  BOOLEAN_CHECKBOX: 'booleancheckbox',
  ENUMERATION: 'enumeration'
};
export var FORM_FIELDS_WITH_OPTIONS = [FORM_FIELD_TYPES.RADIO, FORM_FIELD_TYPES.CHECKBOX, FORM_FIELD_TYPES.BOOLEAN_CHECKBOX, FORM_FIELD_TYPES.ENUMERATION];
export var DEFAULT_FORM_FIELD_NAMES = keyMirror({
  FIRST_NAME: null,
  LAST_NAME: null,
  EMAIL: null
});
export var MEETING_TYPES = {
  PERSONAL: 'personal',
  GROUP: 'group',
  ROUND_ROBIN: 'roundRobin'
};
export var LINK_TYPES = ImmutableMap({
  personal: 'PERSONAL_LINK',
  group: 'GROUP_CALENDAR',
  roundRobin: 'ROUND_ROBIN_CALENDAR'
});
export var LINK_TYPE_PARAMS = ImmutableMap({
  personal: 'personal',
  team: 'team'
});
export var AUTH_ERROR_TYPES = keyMirror({
  USER_DECLINED: null,
  SHARED_INBOX_INVALID_DOWNGRADE: null,
  DEFAULT: null,
  SHARED_INBOX: null
});
export var START_TIME_INTERVALS = keyMirror({
  MEETING_DURATION: null,
  FIVE: null,
  TEN: null,
  FIFTEEN: null,
  TWENTY: null,
  THIRTY: null,
  FORTY_FIVE: null,
  SIXTY: null,
  NINETY: null,
  ONE_HUNDRED_TWENTY: null
});
export var START_TIME_INTERVAL_VALUES = {
  MEETING_DURATION: 'MEETING_DURATION',
  FIVE: 5,
  TEN: 10,
  FIFTEEN: 15,
  TWENTY: 20,
  THIRTY: 30,
  FORTY_FIVE: 45,
  SIXTY: 60,
  NINETY: 90,
  ONE_HUNDRED_TWENTY: 120
};
export var DISPLAY_AVATAR_OPTION = {
  PROFILE_IMAGE: 'PROFILE_IMAGE',
  COMPANY_LOGO: 'COMPANY_LOGO',
  CUSTOM_AVATAR: 'CUSTOM_AVATAR'
};